import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export interface SignupRequestRow {
  id: number;
  personName: string;
  businessName: string;
  email: string;
  suggestedSlug: string;
  status: string;
  createdAt: string;
  decidedAt: string | null;
}

export function usePendingSignupRequests() {
  return useQuery<{ requests: SignupRequestRow[] }>({
    queryKey: ['platform-signup-requests'],
    queryFn: () => api.get<{ requests: SignupRequestRow[] }>('/api/platform/signup-requests?status=pending'),
  });
}

export function useApproveSignupRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, slug }: { id: number; slug?: string }) =>
      api.post<{ ok: boolean; accountId: string }>(`/api/platform/signup-requests/${id}/approve`, { slug }),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['platform-signup-requests'] }),
  });
}

export function useRejectSignupRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.post<{ ok: boolean }>(`/api/platform/signup-requests/${id}/reject`, {}),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['platform-signup-requests'] }),
  });
}
